import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronArrowRightFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M8.172 4.528A14 14 0 0 1 7.921 2.5h1.603c.042.654.11 1.213.213 1.695.198.93.51 1.5.95 1.888.45.399 1.128.69 2.225.873.592.1 1.282.162 2.088.2v1.689c-.806.037-1.496.1-2.088.199-1.097.182-1.775.475-2.226.873-.439.389-.75.958-.949 1.888-.103.482-.17 1.041-.213 1.695H7.921c.045-.755.124-1.43.251-2.028.233-1.092.641-1.991 1.365-2.672H1V7.2h8.537c-.724-.68-1.132-1.58-1.365-2.672"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronArrowRightFilledSize16Glyph.displayName = 'ChevronArrowRightFilledSize16Glyph';
